import { FC } from 'react';
import { useFormContext, Controller, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import TextField from '@app/components/input/TextField';

import messages from '../Address.messages';
import { AddressFormFields } from '../Address.constants';
import ValidationMessage from '../ValidationMessage/ValidationMessage';

export const CompanyField: FC<{ namespace: string }> = ({ namespace }) => {
  const { control, errors } = useFormContext();
  const vatNumberValue = useWatch({
    control,
    name: `${namespace}.${AddressFormFields.VatNumber}`,
    defaultValue: '',
  });
  const isCompanyRequired = !!vatNumberValue;

  return (
    <Controller
      defaultValue=""
      name={`${namespace}.${AddressFormFields.Company}`}
      rules={{
        setValueAs: (value) => value || null,
        required: {
          value: isCompanyRequired,
          //  @ts-expect-error: TS only support string, not ReactElement (react-hook-form.com/api#register)
          message: <ValidationMessage type="required" fieldNameKey="company" />,
        },
      }}
      render={({ ref, ...props }) => (
        <TextField
          autoComplete="organization"
          maxLength={128}
          isValid={!errors[namespace]?.[AddressFormFields.Company]}
          formLabel={
            <>
              <FormattedMessage {...messages.company} />
              {!isCompanyRequired && (
                <>
                  {' '}
                  (<FormattedMessage {...messages.optional} />)
                </>
              )}
            </>
          }
          innerRef={ref}
          {...props}
        />
      )}
    />
  );
};
